module.exports = __webpack_public_path__ + "img/218-Veka Spectral 7016-Anthracite.png";